import React from 'react';
import { _T } from "../../../../../base-react/src/Localization";
import { hooks, models } from '@vote4dance/judging-sdk';
import { Table, Typography } from 'antd';
var Stream = hooks.streams.Stream;
var CheckinSource = models.checkins.CheckinSource;
var CheckinResultSource = models.checkins.CheckinResultSource;
var UserCompetitionItem = models.users.UserCompetitionItem;
import dayjs from 'dayjs';
import { CheckOutlined, WarningOutlined } from '@ant-design/icons';
import { CheckinTeams } from './CheckinTeams';
const { Text } = Typography;
const dateTimeFormat = 'YYYY-MM-DD HH:mm';
export const CheckinOrganizations = (props) => {
    const { competition, disabled } = props;
    const [reports, loadingReports] = Stream(competition ? CheckinSource(competition.competition_id) : undefined);
    const [results, loadingResults] = Stream(competition ? CheckinResultSource(competition.competition_id) : undefined);
    const columns = [
        {
            title: _T('checkin.status.label'),
            render: (text, item) => {
                const isCheckinCancelled = item.team_count == item.team_cancel_count;
                const isCheckinComplete = item.checkin_time != null || isCheckinCancelled;
                const isCheckinApplied = item.applied_at != null;
                const cancelledCount = results ? results.filter(function (result) {
                    return result.organization_name == item.organization_name && ((result.checkin_status != null && result.checkin_status > 0) || result.team_cancelled > 0);
                }).length : 0;
                var cancelled = isCheckinComplete ? isCheckinCancelled ? false : isCheckinApplied ? false : cancelledCount > 0 : undefined;
                var type = undefined;
                var icon = undefined;
                if (cancelled == true) {
                    type = "danger";
                    icon = React.createElement(WarningOutlined, null);
                }
                else if (cancelled == false) {
                    type = "success";
                    icon = React.createElement(CheckOutlined, null);
                }
                return React.createElement(Text, { type: type }, icon);
            }
        },
        {
            title: _T('team.details.team_org.label'),
            dataIndex: 'organization_name'
        },
        {
            title: _T('checkin.status.cancelled'),
            dataIndex: "team_cancel_count",
            render: (text, item) => {
                const cancelledCount = results ? results.filter(function (result) {
                    return result.organization_name == item.organization_name && ((result.checkin_status != null && result.checkin_status > 0) || result.team_cancelled > 0);
                }).length : 0;
                return cancelledCount;
            }
        },
        {
            title: _T('team.title'),
            dataIndex: "team_count"
        },
        {
            title: _T('users.name'),
            dataIndex: 'user_id',
            render: (text, item) => text && UserCompetitionItem.getFullName(item)
        },
        {
            title: _T('checkin.time'),
            dataIndex: 'checkin_time',
            render: (text, item) => text && dayjs.utc(text).tz(competition === null || competition === void 0 ? void 0 : competition.competition_timezone).format(dateTimeFormat)
        },
        {
            title: _T('checkin.phone'),
            dataIndex: 'checkin_phone'
        },
    ].filter(column => Object.keys(column).length > 0);
    const footer = (data) => {
        const cancelledCount = results ? results.filter(function (result) {
            return (result.checkin_status != null && result.checkin_status > 0) || result.team_cancelled > 0;
        }).length : 0;
        const totalSum = data ? data.reduce((accumulator, currentValue) => (accumulator || 0) + (parseInt(currentValue.team_count) || 0), 0) : 0;
        return (React.createElement(Table.Summary.Row, null,
            React.createElement(Table.Summary.Cell, { index: 0, colSpan: 2 }, _T('common.total')),
            React.createElement(Table.Summary.Cell, { index: 1 },
                React.createElement(Text, null, data.length)),
            React.createElement(Table.Summary.Cell, { index: 2 },
                React.createElement(Text, null, cancelledCount)),
            React.createElement(Table.Summary.Cell, { index: 3 },
                React.createElement(Text, null, totalSum))));
    };
    return (React.createElement(Table, { columns: columns, expandable: {
            expandedRowRender: (item) => React.createElement(CheckinTeams, { competition: competition, item: item, disabled: disabled }),
            expandRowByClick: true
        }, dataSource: reports, pagination: false, summary: footer, loading: loadingReports || loadingResults, size: "small", rowKey: "organization_name" }));
};
